import { Graph, Node } from "../../models";
import { ActiveItemType, RootState } from "../../types";

export const difficultiesSelector = (state: RootState): any =>
  state.game.difficulty;

export const gameGraphSelector = (state: RootState): Graph => state.game.graph;

export const isPlayingSelector = (state: RootState): boolean =>
  state.game.isPlaying;

export const isStartedSelector = (state: RootState): boolean =>
  state.game.isStarted;

export const isWonSelector = (state: RootState): boolean => state.game.isWon;

export const currentLevelSelector = (state: RootState): number =>
  state.game.currentLevel;

export const activeGameItemSelector = (state: RootState): ActiveItemType =>
  state.game.activeGameItem;

export const gameAnswersSelector = (state: RootState): Node[] =>
  state.game.gameAnswers;

export const distanceGameTypeSelector = (state: RootState): any =>
  state.game.distanceGameType;

export const startNodeSelector = (state: RootState): Node | null =>
  state.game.startNode;

export const endNodeSelector = (state: RootState): Node | null =>
  state.game.endNode;

export const currentNodeSelector = (state: RootState): Node | null =>
  state.game.currentNode;
